module.exports = __webpack_public_path__ + "c42714764e8cf5bfac4ab100df6d326c.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/gamecenter/en/luckyfruit.jpg
// module id = 242
// module chunks = 30